@if (!item.hidden && isVisibleByNppPermission) {
  <!-- normal collapse -->
  @if (!item.url && !item.function) {
    <a class="nav-link" [ngClass]="item.classes" (click)="toggleOpen($event)">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.url -->
  @if (item.url && !item.externalUrl && !item.function) {
    <a
      class="nav-link"
      [ngClass]="item.classes"
      (click)="toggleOpen($event)"
      [routerLink]="[item.url]"
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{
        paths: item.exactMatch ? 'exact' : 'subset',
        queryParams: 'ignored',
        matrixParams: 'ignored',
        fragment: 'ignored'
      }"
      [target]="item.openInNewTab ? '_blank' : '_self'"
    >
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl -->
  @if (item.url && item.externalUrl && !item.function) {
    <a
      class="nav-link"
      [ngClass]="item.classes"
      (click)="toggleOpen($event)"
      [href]="item.url"
      [target]="item.openInNewTab ? '_blank' : '_self'"
    >
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.function -->
  @if (!item.url && item.function) {
    <span class="nav-link" [ngClass]="item.classes" (click)="toggleOpen($event); item.function()">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </span>
  }
  <!-- item.url && item.function -->
  @if (item.url && !item.externalUrl && item.function) {
    <a
      class="nav-link"
      [ngClass]="item.classes"
      (click)="toggleOpen($event); item.function()"
      [routerLink]="[item.url]"
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{
        paths: item.exactMatch ? 'exact' : 'subset',
        queryParams: 'ignored',
        matrixParams: 'ignored',
        fragment: 'ignored'
      }"
    >
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl && item.function -->
  @if (item.url && item.externalUrl && item.function) {
    <a
      class="nav-link"
      [ngClass]="item.classes"
      (click)="toggleOpen($event); item.function()"
      [href]="item.url"
      [target]="item.openInNewTab ? '_blank' : '_self'"
    >
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <ng-template #itemContent>
    @if (item.icon) {
      <mat-icon class="nav-link-icon">{{ item.icon }}</mat-icon>
    }
    <span class="nav-link-title">{{ item.title }}</span>
    @if (item.badge) {
      <span class="nav-link-badge" [style.background-color]="item.badge.bg" [style.color]="item.badge.fg">
        {{ item.badge.title }}
      </span>
    }
    <mat-icon class="collapsable-arrow">keyboard_arrow_right</mat-icon>
  </ng-template>
  <div class="children" [@slideInOut]="isOpen" [ngClass]="{ classBlock: isOpen }">
    @for (child of item.children; track child) {
      @if (!item.filtraFigli || isVisible(child)) {
        @if (child.type == 'item') {
          <fuse-nav-vertical-item [item]="child" (click)="tracker?.(child)"></fuse-nav-vertical-item>
        }
        @if (child.type == 'collapsable') {
          <fuse-nav-vertical-collapsable
            [item]="child"
            [isVisible]="isVisible"
            [tracker]="tracker"
            (click)="tracker?.(child)"
          ></fuse-nav-vertical-collapsable>
        }
        @if (child.type == 'group') {
          <fuse-nav-vertical-group [item]="child"></fuse-nav-vertical-group>
        }
      }
    }
  </div>
}
